/** Synthetic shipping method ID — never sent to Sendcloud. */
export const OWN_DELIVERY_METHOD_ID = -1001

export const OWN_DELIVERY_CARRIER = 'efreight'
export const OWN_DELIVERY_METHOD_NAME = 'Own Delivery'
export const OWN_DELIVERY_SETTING_KEY = 'own_delivery_enabled'

/**
 * Prefer Own Delivery when road distance from the E-freight warehouse
 * (Amersfoort) is within this radius. Uses the same distance stack as the calculator.
 */
export const OWN_DELIVERY_RECOMMENDED_RADIUS_KM = 20

export function isOwnDeliveryMethodId(id: number | null | undefined): boolean {
  return id === OWN_DELIVERY_METHOD_ID
}

export function isWithinOwnDeliveryRecommendRadius(
  distanceKm: number | null | undefined,
): boolean {
  return (
    typeof distanceKm === 'number' &&
    Number.isFinite(distanceKm) &&
    distanceKm <= OWN_DELIVERY_RECOMMENDED_RADIUS_KM
  )
}

export function isOwnDeliveryShipment(shipment: {
  carrier_name?: string | null
  shipping_method?: string | null
  sendcloud_shipment_id?: string | null
}): boolean {
  if (shipment.carrier_name?.toLowerCase() === OWN_DELIVERY_CARRIER) return true
  if (shipment.shipping_method === OWN_DELIVERY_METHOD_NAME) return true
  if (shipment.sendcloud_shipment_id?.startsWith('own-')) return true
  return false
}
